import useAccount from "@/modules/account/hooks/useAccount";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface ImpersonationBannerProps {
  onlyIcon?: boolean;
}

export default function ImpersonationBanner({
  onlyIcon = false,
}: ImpersonationBannerProps) {
  const { impersonateCognitoId, account } = useAccount();
  const { t } = useTranslation();

  if (!impersonateCognitoId) {
    return null;
  }

  const adminName = account?.authenticated_as?.full_name;

  if (!adminName) {
    return null;
  }

  if (onlyIcon) {
    return (
      <div className="px-2 py-1">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="flex items-center justify-center p-2">
                <AlertTriangle className="w-4 h-4 text-yellow-600 flex-shrink-0" />
              </div>
            </TooltipTrigger>
            <TooltipContent side="right">
              {t("impersonation.banner.authenticatedAs", { name: adminName })}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    );
  }

  return (
    <div className="px-2 py-1">
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
        <div className="flex items-start gap-2">
          <AlertTriangle className="w-4 h-4 text-yellow-600 flex-shrink-0 mt-0.5" />
          <div className="min-w-0 flex-1">
            <div className="text-xs font-medium text-black mb-1">
              {t("impersonation.banner.adminLabel")}
            </div>
            <div className="text-sm font-semibold text-black truncate">
              {adminName}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
